import { objectEntries, objectFromEntries } from '~/web-frontend-core/base/lib';
import Subscribtion from '~/web-frontend-core/base/Subscribtion';
import { COLUMN_WIDTH } from '~/web-frontend-core/api/const/base';
export class BaseMobileCategories extends Subscribtion {
    constructor(width = COLUMN_WIDTH.MEDIUM, onTablesSelect) {
        super();
        this.width = width;
        this.onTablesSelect = onTablesSelect;
        /**
         * по WS приходит другой формат, поэтому временно
         * храним данные filterTables в отдельном свойстве
         */
        this.data = new Map();
        this.order = new Map();
        /** Категории, выбранные пользователем */
        this.selectedCategories = new Map();
        /**
         * Хранилище соответствия спорта-матча чтобы держать в избранном таблицы разных матчей одного спорта
         */
        this.sportID = {};
        this.select = this.select.bind(this);
    }
    getSportID(matchID) {
        return this.sportID[matchID];
    }
    getData(matchID) {
        return this.data.get(matchID) || null;
    }
    deleteCategories(matchID, categoryIDs) {
        if (categoryIDs.length === 0) {
            return;
        }
        const selectedCategories = this.selectedCategories.get(matchID);
        const data = this.getData(matchID);
        if (!data) {
            throw new Error(`No data for ${matchID}`);
        }
        categoryIDs.forEach((categoryID) => {
            selectedCategories.delete(categoryID);
            delete data[categoryID];
        });
        this.select(matchID);
    }
    /**
     * Выбрать категорию
     * @param matchID
     * @param categoryIDs
     * @param isSelected
     */
    select(matchID, categoryIDs = Array.from(
    // @ts-ignore
    this.selectedCategories.has(matchID) && this.selectedCategories.get(matchID).values() || []), isSelected = true) {
        if (!this.selectedCategories.has(matchID)) {
            return;
        }
        const selectedCategories = this.selectedCategories.get(matchID);
        if (!isSelected) {
            this.unselectCategories(matchID, categoryIDs);
            return;
        }
        if (categoryIDs.every((categoryID) => selectedCategories.has(categoryID))) {
            return;
        }
        const unselectCategories = objectFromEntries(Array.from(selectedCategories.values() || [])
            .map((categoryID) => [categoryID, { isSelected: false }]));
        selectedCategories.clear();
        categoryIDs[0] && selectedCategories.add(categoryIDs[0]);
        const newStates = Object.assign(Object.assign({}, unselectCategories), { [categoryIDs[0]]: { isSelected: true } });
        this.selectTables(matchID);
        this.assignStates(matchID, newStates);
    }
    unselectCategories(matchID, categoryIDs = Array.from(
    // @ts-ignore
    this.selectedCategories.has(matchID) && this.selectedCategories.get(matchID).values() || [])) {
        const selectedCategories = this.selectedCategories.get(matchID);
        categoryIDs.forEach((c) => { selectedCategories.delete(c); });
        const newStates = Object.assign(
        // очередность важна, isSelected:true должны быть в конце
        objectFromEntries(categoryIDs.map((categoryID) => [categoryID, { isSelected: false }])), objectFromEntries(Array
            .from(selectedCategories.values() || [])
            .map((categoryID) => [categoryID, { isSelected: true }])));
        this.assignStates(matchID, newStates);
        this.selectTables(matchID);
    }
    /** Выбирает все таблицы выбранных категорий */
    selectTables(matchID) {
        const categories = this.getData(matchID);
        if (!categories) {
            throw new Error('Попытка выбрать несуществующую категорию!');
        }
        const selectedCategories = this.selectedCategories.get(matchID);
        const noCategoriesSelected = (selectedCategories.size === 0);
        if (noCategoriesSelected) {
            this.onTablesSelect(matchID, [], true);
            return;
        }
        this.onTablesSelect(matchID, [], false);
        const selectedTables = Array.from(selectedCategories.values() || [])
            .map((categoryID) => { var _a; return ((_a = categories[categoryID]) === null || _a === void 0 ? void 0 : _a.tables) || []; })
            .reduce((allTables, tables) => allTables.concat(tables), []);
        this.onTablesSelect(matchID, selectedTables, true);
    }
    /**
     * в отличие от update здесь состояния могут изменяться частично
     * @param matchID
     * @param newStates
     */
    assignStates(matchID, newStates) {
        const categories = this.getData(matchID);
        if (!categories) {
            throw new Error('Попытка выбрать категории несуществующего события ' + matchID);
        }
        objectEntries(newStates)
            .filter(([categoryID]) => categoryID in categories)
            .forEach(([categoryID, newState]) => { Object.assign(categories[categoryID] || {}, newState); });
        this.notify(matchID);
    }
    clear() {
        this.data.clear();
        this.selectedCategories.clear();
        this.notify();
    }
    clearGame(matchID) {
        this.data.set(matchID, {});
        this.order.delete(matchID);
        this.notify(matchID);
    }
    deleteGame(matchID) {
        this.data.delete(matchID);
        this.selectedCategories.delete(matchID);
        this.notify(matchID);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/outcomes.mobile/additional/categories/Base.mobile.js